export default __webpack_public_path__ + "static/media/problem_step.6868ca71.svg";